import { z } from 'zod';

// Auto-cancellation window for unbooked referrals, stored in DAYS. The
// scheduled Cancel*SentReferral jobs cancel a sent / appointment-cancelled
// referral whose createdAt is older than the window; `null` disables the job
// for the organization.
// L&G / Healix / Aviva: 56 (8 weeks); L&G CI: 168 (24 weeks, PRM-110
// Decision 7).
// The paused-referral window deliberately does NOT live here — it is part of
// the pause policy (ReferralPausingSettingsSchema), whose fields must inherit
// together.
// A present doc fully defines the group: the field is required (nullable).
export const ReferralAutoCancellationSettingsSchema = z.strictObject({
  cancelSentAfterDays: z.number().int().positive().nullable(),
});

export type ReferralAutoCancellationSettings = z.infer<
  typeof ReferralAutoCancellationSettingsSchema
>;
